module.exports = ".center-block {\n    float: none !important;\n  }\n\n.update-pwd {\n  padding-top: 100px;\n  margin-bottom: 205px;\n}\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/update-password/update-password.component.css
// module id = ./src/app/main/update-password/update-password.component.css
// module chunks = main